export const fileTitles = [{
    name: 'training-1.jpg',
    alt: "sign"
  },
  {
    name: 'training-2.jpg',
    alt: "taking to children"
  },
  {
    name: 'training-3.jpg',
    alt: "sharing wisdom"
  },
  {
    name: 'training-4.jpg',
    alt: 'talking about health'
  },
  {
    name: 'training-5.jpg',
    alt: 'sharing ideas'
  },
  {
    name: 'training-6.jpg',
    alt: 'Talking about nutrition'
  },
  {
    name: 'training-7.jpg',
    alt: 'Kids havin fun'
  },
  {
    name: 'training-8.jpg',
    alt: 'Light lecture'
  },
  {
    name: "training-9.jpg",
    alt: 'kids listening'
  },
  {
    name: 'training-10.jpg',
    alt: 'practicising more knowledge'
  },
  {
    name: "training-11.jpg",
    alt: 'kids grasping knowledge about their issues'
  },
  {
    name: 'training-12.jpg',
    alt: 'showing charts'
  }

];



// WEBPACK FOOTER //
// ./src/components/Events/KishoreTraining/Kishore-data.js